import PropTypes from "prop-types";

// Third party
import moment from "moment";

// Layouts
import PayPlanInfoLoader from "@/Layouts/components/Skeletons/PayPlanInfoLoader";

// MUI
import { Grid, Stack, Typography } from "@mui/material";

// Constants
import { DATE_FORMAT } from "@/Constants/date";
const FONT_FAMILY = "var(--font-family-v1)";

const typographyProps = {
	fontFamily: FONT_FAMILY,
	fontWeight: "500",
};

const DisplayPayPlanInfo = (props) => {
	const info = [
		{
			field: "Effective",
			value: props.payPlanData.effectiveDate
				? moment.utc(props.payPlanData.effectiveDate).format(DATE_FORMAT.monthAbbrDatePadded)
				: "",
		},
		{
			field: "Acknowledged",
			value: props.payPlanData.acknowledgementDate
				? moment.utc(props.payPlanData.acknowledgementDate).format(DATE_FORMAT.monthAbbrDatePadded)
				: "",
		},
		{
			field: "Assigned",
			value: props.payPlanData.assignmentDate
				? moment.utc(props.payPlanData.assignmentDate).format(DATE_FORMAT.monthAbbrDatePadded)
				: "",
		},
	];

	return (
		<Grid container sx={{ paddingBottom: "20px", margin: "-30px 0 10px -15px" }}>
			{props.loading ? (
				<PayPlanInfoLoader />
			) : (
				<>
					<Stack direction="row" justifyContent={"space-between"} spacing={2} width={"100%"}>
						<Typography sx={{ ...typographyProps, fontSize: "24px", color: "var(--text-color)" }}>
							{props?.position} Pay Plan {props.name}
						</Typography>
						{props.payPlanAction}
					</Stack>
					{info.map((element, key) => (
						<Grid container key={`pay_plan_info_${element?.value}_${key}`} flexDirection="row">
							<Typography sx={{ ...typographyProps, fontSize: "16px", color: "#b3b3b3" }}>{element?.field || ""}</Typography>
							<Typography
								sx={{
									...typographyProps,
									fontSize: "16px",
									color: "var(--text-color)",
									marginLeft: "8px",
								}}
							>
								{element.value}
							</Typography>
						</Grid>
					))}
				</>
			)}
		</Grid>
	);
};

DisplayPayPlanInfo.propTypes = {
	name: PropTypes.string,
	payPlanData: PropTypes.object,
	loading: PropTypes.bool,
	payPlanAction: PropTypes.element,
	position: PropTypes.string,
};

export default DisplayPayPlanInfo;
